import { render, staticRenderFns } from "./RenderizacaoFormularioDinamicoComponent.vue?vue&type=template&id=348ec52b"
import script from "./RenderizacaoFormularioDinamicoComponent.vue?vue&type=script&lang=js"
export * from "./RenderizacaoFormularioDinamicoComponent.vue?vue&type=script&lang=js"
import style0 from "./RenderizacaoFormularioDinamicoComponent.vue?vue&type=style&index=0&id=348ec52b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports